import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref } from 'vue';
import ProductItem from '../productItem/ProductItem.vue';
import { useI18n } from 'vue-i18n';
import { useLess } from '@/models/hooks';
import constants, { encryptedMarketplaceId } from '@/constants';
import { getRecommendAsins, RECOMMENDATION_TYPE } from '@/models/api/asinsRecommendationsAndOrderRaisingApi';
import { getAsinBatch } from '@/models/api/detailPageApi';
var pageSize = 10;
export default {
  __name: 'RecommendedAsins',
  props: {
    title: {
      type: String
    },
    columns: {
      type: Number,
      default: () => 2
    },
    backgroundColor: {
      type: String,
      default: () => ''
    },
    isInDetailPage: {
      type: Boolean,
      default: () => false
    },
    category: {
      type: String,
      default: () => ''
    },
    categoryId: {
      type: String,
      default: () => ''
    }
  },
  emits: ['onAddCartConfirm', 'reloadingDetailPageData', 'openApp', 'isLoading'],
  setup(__props, {
    expose: __expose,
    emit
  }) {
    var props = __props;
    useLess('components/RecommendedAsins.less');
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var isListloading = ref(false);
    var isFinished = ref(false);
    var recommendedAsinList = ref([]);
    var pageIndex = ref('');
    var getSearch = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(isRefresh = false) {
        var _data$pagination, _data$pagination2, _data$pagination3, _yield$getRecommendAs, data, _yield$getAsinBatch, asinData, _data$pagination4;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (isRefresh) pageIndex.value = '';
              _context.prev = 1;
              _context.next = 4;
              return getRecommendAsins({
                language: constants.ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP[constants.ENCRYPTED_MARKETPLACE_ID],
                recommendationType: RECOMMENDATION_TYPE.CATEGORY,
                recommendationTypeId: props.category,
                exclusiveStartKey: encodeURIComponent(pageIndex.value),
                pageSize
              });
            case 4:
              _yield$getRecommendAs = _context.sent;
              data = _yield$getRecommendAs.data;
              if (!(data !== null && data !== void 0 && (_data$pagination = data.pagination) !== null && _data$pagination !== void 0 && _data$pagination.lastEvaluatedKey)) isFinished.value = true;
              if (!(data !== null && data !== void 0 && data.asinList)) {
                _context.next = 14;
                break;
              }
              _context.next = 10;
              return getAsinBatch({
                ids: data === null || data === void 0 ? void 0 : data.asinList.toString(),
                marketplace: encryptedMarketplaceId,
                withCache: false,
                allowOtherOffer: false,
                returnableFlagSkipped: false
              });
            case 10:
              _yield$getAsinBatch = _context.sent;
              asinData = _yield$getAsinBatch.data;
              if (isRefresh) {
                recommendedAsinList.value = [];
              }
              asinData === null || asinData === void 0 ? void 0 : asinData.forEach(item => {
                if (item.selectionEligible) {
                  var _item$ourPrice, _item$ourPrice$amount, _constants$MERCHANT_B;
                  recommendedAsinList.value.push(_objectSpread(_objectSpread({}, item), {}, {
                    asin: item.asin,
                    merchantId: item.merchantId,
                    isGlobalStoreFreeShippingProgram: item.delivery.isGlobalStoreFreeShippingProgram,
                    buyPrice: item === null || item === void 0 ? void 0 : (_item$ourPrice = item.ourPrice) === null || _item$ourPrice === void 0 ? void 0 : (_item$ourPrice$amount = _item$ourPrice.amount) === null || _item$ourPrice$amount === void 0 ? void 0 : _item$ourPrice$amount.toFixed(2),
                    title: item.title,
                    mainImage: item.mainImage,
                    gsBadge: (_constants$MERCHANT_B = constants.MERCHANT_BADGE_MAP[item.merchantId]) === null || _constants$MERCHANT_B === void 0 ? void 0 : _constants$MERCHANT_B.badgeURL
                  }));
                }
              });
            case 14:
              emit('isLoading', true, !(data !== null && data !== void 0 && (_data$pagination2 = data.pagination) !== null && _data$pagination2 !== void 0 && _data$pagination2.lastEvaluatedKey));
              if (data !== null && data !== void 0 && (_data$pagination3 = data.pagination) !== null && _data$pagination3 !== void 0 && _data$pagination3.lastEvaluatedKey) {
                pageIndex.value = data === null || data === void 0 ? void 0 : (_data$pagination4 = data.pagination) === null || _data$pagination4 === void 0 ? void 0 : _data$pagination4.lastEvaluatedKey;
              }
              _context.next = 22;
              break;
            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](1);
              isFinished.value = true;
              console.error(_context.t0, 'api---error---getRecommendAsins');
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 18]]);
      }));
      return function getSearch() {
        return _ref.apply(this, arguments);
      };
    }();
    var onLoad = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              emit('isLoading', false, !pageIndex.value);
              _context2.next = 3;
              return getSearch();
            case 3:
              isListloading.value = false;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function onLoad() {
        return _ref2.apply(this, arguments);
      };
    }();
    var onPullRefresh = () => {
      pageIndex.value = '';
      recommendedAsinList.value = [];
      onLoad();
    };
    var onAddCartConfirm = (status, asin) => {
      emit('onAddCartConfirm', status, asin);
    };
    __expose({
      onPullRefresh,
      getSearch
    });
    return (_ctx, _cache) => {
      var _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock("div", {
        class: "recommended-asins",
        style: _normalizeStyle({
          background: __props.backgroundColor
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass(["title", {
          'title-detail': __props.isInDetailPage
        }])
      }, _toDisplayString(__props.title ? __props.title : _unref(t)('common.RECOMMENDED_COMMODITIES')), 3), _createVNode(_component_van_list, {
        loading: isListloading.value,
        "onUpdate:loading": _cache[3] || (_cache[3] = $event => isListloading.value = $event),
        finished: isFinished.value,
        "finished-text": _unref(t)('modules.detailPage.NO_MORE'),
        "loading-text": _unref(t)('modules.commonComponent.pullRefresh.LOADING'),
        onLoad: onLoad
      }, _createSlots({
        default: _withCtx(() => [_createVNode(ProductItem, {
          asinList: recommendedAsinList.value,
          "onUpdate:asinList": _cache[0] || (_cache[0] = $event => recommendedAsinList.value = $event),
          columns: __props.columns,
          isShowUnit: true,
          onAddCartConfirm: onAddCartConfirm,
          onReloadingDetailPageData: _cache[1] || (_cache[1] = $event => emit('reloadingDetailPageData')),
          onOpenApp: _cache[2] || (_cache[2] = $event => emit('openApp'))
        }, null, 8, ["asinList", "columns"])]),
        _: 2
      }, [_ctx.$slots.loading ? {
        name: "loading",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "loading")]),
        key: "0"
      } : undefined]), 1032, ["loading", "finished", "finished-text", "loading-text"])], 4);
    };
  }
};